import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import roleService from './roleService'

// Get roles
export const getRoles = createAsyncThunk('roles', async (params: {}, thunkAPI) => {
  try {
    return await roleService.getRoles({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSystems = createAsyncThunk('systems', async (_, thunkAPI) => {
  try {
    return await roleService.getSystems()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get permissions
export const getPermissions = createAsyncThunk(
  'permissions',
  async (system_id: string, thunkAPI) => {
    try {
      return await roleService.getPermissions(system_id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create or update role
export const createRole = createAsyncThunk('create-role', async (data: {}, thunkAPI) => {
  try {
    return await roleService.createRole({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// edit role
export const editRole = createAsyncThunk('role-edit', async (id: string, thunkAPI) => {
  try {
    return await roleService.EditRole(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete role
export const deleteRole = createAsyncThunk('role-delete', async (role_id: string, thunkAPI) => {
  try {
    return await roleService.deleteRole(role_id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Role Types
type RoleState = {
  errors: any
}

const initialState: RoleState = {
  errors: '',
}

export const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createRole.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = roleSlice.actions
export default roleSlice.reducer
